var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Youtube"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.860352,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#1C202D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5673 19.944C52.3047 17.6982 50.9345 17.2851 48.1447 17.128C45.3578 16.9389 38.3498 16.8604 32.2785 16.8604C26.1956 16.8604 19.1847 16.9389 16.4007 17.1251C13.6167 17.2851 12.2436 17.6953 10.9695 19.944C9.66909 22.1869 9 26.0502 9 32.8516V32.8749C9 39.6473 9.66909 43.5396 10.9695 45.7593C12.2436 48.0051 13.6138 48.4124 16.3978 48.6014C19.1847 48.7644 26.1956 48.8604 32.2785 48.8604C38.3498 48.8604 45.3578 48.7644 48.1476 48.6044C50.9375 48.4153 52.3076 48.008 53.5702 45.7622C54.8822 43.5425 55.5455 39.6502 55.5455 32.8778V32.8545C55.5455 26.0502 54.8822 22.1869 53.5673 19.944ZM26.4546 41.5878V24.1333L41 32.8606L26.4546 41.5878Z",
    fill: "#6C84F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube1);
export default __webpack_public_path__ + "static/media/Youtube1.fae30662e201503dd9e9f36a37ef6065.svg";
export { ForwardRef as ReactComponent };